
// function createLogger() {
//   const clientId = `mqtt_${Math.random().toString(16).slice(3)}`;
//   const mqttClient = mqtt.connect("ws://central.r3sist.com.br:9001", {
//     clientId,
//     username: "r3sist",
//     password: "r3sist",
//     connectTimeout: 4000,
//     reconnectPeriod: 1000,
//   });

//   mqttClient.on("connect", () => {
//     console.log("connected");
//     mqttClient.subscribe("/r3/log", () => {
//       console.log("subscribed");
//     });
//   });

//   return mqttClient;
// }

// const mqttClient = createLogger();

export default defineNuxtPlugin(() => {
  return {
    provide: {
      // R3Log: console.log('teste'),
      // R3log: mqttClient,
    },
  };
});
